import { debounce } from 'lodash';
import { enqueueSnackbar } from 'notistack';
import { listInventoryReceivingsApi, upsertInventoryReceivingApi } from 'api/inventory';
import { stockManagementActions } from 'store/slices/stockManagementSlice';
import { handleError } from './errorHandlerThunks';

export const listReceivingsByPage =
  ({ page }) =>
  (dispatch, getState) => {
    const { filter } = getState().inventory.stockManagement;

    dispatch(stockManagementActions.updateCurrentPage(page));

    return listInventoryReceivingsApi({ filter, page })
      .then(({ items, totalCount }) =>
        dispatch(stockManagementActions.loadReceivings({ page, items, totalCount }))
      )
      .catch((error) => dispatch(handleError({ error })));
  };

export const debouncedListReceivings = debounce(({ dispatch }) => {
  return dispatch(listReceivingsByPage({ page: 1 })).finally(() =>
    dispatch(stockManagementActions.setLoading(false))
  );
}, 1000);

export const filterReceivings =
  ({ filter }) =>
  (dispatch) => {
    dispatch(stockManagementActions.setLoading(true));
    dispatch(stockManagementActions.updateFilter(filter));
    debouncedListReceivings({ dispatch });
  };

export const createInventoryReceiving =
  ({ input, onSuccess }) =>
  (dispatch) =>
    upsertInventoryReceivingApi(input)
      .then((receiving) => {
        enqueueSnackbar('Stock receiving created successfully', { variant: 'success' });
        dispatch(listReceivingsByPage({ page: 1 }));
        onSuccess?.(receiving);
      })
      .catch((error) => dispatch(handleError({ error })));

export const addLinesToReceiving =
  ({ receivingId, lines, onSuccess }) =>
  (dispatch, getState) =>
    upsertInventoryReceivingApi({ receivingId, lines })
      .then((receiving) => {
        enqueueSnackbar('Lines added successfully', { variant: 'success' });
        const { currentPage } = getState().inventory.stockManagement;
        dispatch(listReceivingsByPage({ page: currentPage }));
        onSuccess?.(receiving);
      })
      .catch((error) => dispatch(handleError({ error })));
